
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyPilarTShape as ObiBuoyPilarTShapeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-pilar-t-shape.js';
 
 
 

 
 export const ObiBuoyPilarTShape = createComponent({
   react: React,
   tagName: 'obi-buoy-pilar-t-shape',
   elementClass: ObiBuoyPilarTShapeElement,
   events: {
     
   }
  });
 
 